import type { Cinema } from "@/types/cinema";

export const cities = ["全部", "北京", "上海", "广州", "深圳", "成都", "杭州"];
export const cinemaBrands = ["九七国际影城", "万达影城", "CGV影城", "保利国际影城", "横店影视城"];

export const cinemas: Cinema[] = [
  {
    id: "c01",
    name: "九七国际影城（三里屯旗舰店）",
    brand: "九七国际影城",
    city: "北京",
    district: "朝阳区",
    address: "北京市朝阳区三里屯路 19 号院太古里南区 4 层",
    phone: "010-6588-9700",
    rating: 4.9,
    logo: "",
    images: [
      "https://readdy.ai/api/search-image?query=modern%20luxury%20cinema%20lobby%20interior%20with%20warm%20ambient%20lighting%2C%20deep%20blue%20and%20orange%20accents%2C%20clean%20minimal%20design%2C%20concession%20counter%2C%20architectural%20photography&width=1200&height=800&seq=cinema-hall-c01a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=premium%20imax%20screening%20room%20with%20rows%20of%20red%20velvet%20seats%20and%20a%20huge%20screen%2C%20deep%20blue%20dim%20lighting%20with%20orange%20aisle%20lights%2C%20cinematic%20architectural%20photography&width=1200&height=800&seq=cinema-hall-c01b&orientation=landscape",
    ],
    facilities: ["IMAX 影厅", "杜比全景声", "可在线选座", "会员储值", "免费停车", "亲子厅"],
    intro:
      "九七国际影城三里屯旗舰店拥有 12 个标准化影厅，配备 IMAX 与杜比全景声系统，是北京核心商圈最受欢迎的观影地标之一。",
    traffic: "地铁 10 号线团结湖站 A 口步行 8 分钟；商场 B2 层提供 3 小时免费停车。",
    offers: ["会员日全场 5 折", "学生凭证件享 8 折", "购票满 2 张赠爆米花套餐"],
  },
  {
    id: "c02",
    name: "万达影城（CBD 国贸店）",
    brand: "万达影城",
    city: "北京",
    district: "朝阳区",
    address: "北京市朝阳区建国路 87 号国贸商城 6 层",
    phone: "010-8595-1188",
    rating: 4.7,
    logo: "",
    images: [
      "https://readdy.ai/api/search-image?query=upscale%20cinema%20entrance%20hall%20with%20glowing%20movie%20posters%20and%20marble%20floor%2C%20deep%20blue%20lighting%20with%20warm%20orange%20accents%2C%20modern%20architectural%20photography&width=1200&height=800&seq=cinema-hall-c02a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=cozy%20cinema%20auditorium%20with%20wide%20reclining%20seats%20and%20soft%20dim%20blue%20lighting%2C%20large%20curved%20screen%2C%20cinematic%20architectural%20photography&width=1200&height=800&seq=cinema-hall-c02b&orientation=landscape",
    ],
    facilities: ["杜比影院", "4DX", "可在线选座", "会员积分", "咖啡吧"],
    intro:
      "国贸万达影城地处北京 CBD 核心，交通便利、配套完善，主打商务与商务社交观影体验，拥有 9 个豪华影厅。",
    traffic: "地铁 1 号线 / 10 号线国贸站直达商场；写字楼与商场共用地下车库。",
    offers: ["会员积分兑好礼", "工作日午间场特惠"],
  },
  {
    id: "c03",
    name: "CGV 影城（西单大悦城店）",
    brand: "CGV影城",
    city: "北京",
    district: "西城区",
    address: "北京市西城区西单北大街 131 号大悦城 8 层",
    phone: "010-6656-3300",
    rating: 4.6,
    logo: "",
    images: [
      "https://readdy.ai/api/search-image?query=stylish%20modern%20cinema%20lobby%20with%20neon%20accents%20and%20geometric%20ceiling%20design%2C%20deep%20blue%20lighting%20with%20warm%20orange%20highlights%2C%20architectural%20photography&width=1200&height=800&seq=cinema-hall-c03a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=4dx%20motion%20seats%20in%20a%20futuristic%20cinema%20auditorium%2C%20deep%20blue%20ambient%20lighting%20with%20orange%20edge%20accents%2C%20high%20tech%20cinematic%20architectural%20photography&width=1200&height=800&seq=cinema-hall-c03b&orientation=landscape",
    ],
    facilities: ["4DX 影厅", "ScreenX", "可在线选座", "儿童乐园"],
    intro:
      "西单 CGV 影城以 4DX 与 ScreenX 特效厅著称，是年轻观众追求沉浸式观影体验的热门选择，共设 7 个主题影厅。",
    traffic: "地铁 1 号线 / 4 号线西单站地铁口直达商场。",
    offers: ["学生特惠日 6 折", "情侣双人套餐"],
  },
  {
    id: "c04",
    name: "保利国际影城（南京路店）",
    brand: "保利国际影城",
    city: "上海",
    district: "黄浦区",
    address: "上海市黄浦区南京东路 300 号 5 层",
    phone: "021-6321-9700",
    rating: 4.8,
    logo: "",
    images: [
      "https://readdy.ai/api/search-image?query=elegant%20art%20deco%20cinema%20lobby%20with%20golden%20lighting%20and%20deep%20blue%20tones%2C%20marble%20columns%2C%20luxury%20architectural%20photography&width=1200&height=800&seq=cinema-hall-c04a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=luxury%20vip%20cinema%20screening%20room%20with%20plush%20leather%20seats%20and%20soft%20blue%20ambient%20lighting%2C%20warm%20orange%20accents%2C%20architectural%20photography&width=1200&height=800&seq=cinema-hall-c04b&orientation=landscape",
    ],
    facilities: ["VIP 豪华厅", "杜比全景声", "可在线选座", "精品餐饮"],
    intro:
      "南京路保利国际影城主打高端观影体验，设有 VIP 豪华厅与精品餐饮服务，是上海外滩商圈的地标影院。",
    traffic: "地铁 2 号线 / 10 号线南京东路站步行 3 分钟。",
    offers: ["VIP 厅会员专享折扣", "生日当月免费赠票"],
  },
  {
    id: "c05",
    name: "万达影城（五角场店）",
    brand: "万达影城",
    city: "上海",
    district: "杨浦区",
    address: "上海市杨浦区淞沪路 77 号合生汇 6 层",
    phone: "021-6565-8800",
    rating: 4.5,
    logo: "",
    images: [
      "https://readdy.ai/api/search-image?query=bustling%20modern%20cinema%20ticket%20hall%20with%20digital%20poster%20walls%2C%20deep%20blue%20lighting%20with%20orange%20accents%2C%20architectural%20photography&width=1200&height=800&seq=cinema-hall-c05a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=standard%20cinema%20auditorium%20with%20comfortable%20seats%20and%20large%20screen%2C%20deep%20blue%20dim%20lighting%2C%20cinematic%20architectural%20photography&width=1200&height=800&seq=cinema-hall-c05b&orientation=landscape",
    ],
    facilities: ["IMAX 影厅", "可在线选座", "免费停车", "亲子厅"],
    intro:
      "五角场万达影城位于大学城商圈，交通便利、票价亲民，是学生与年轻家庭观影的高性价比选择。",
    traffic: "地铁 10 号线五角场站直达合生汇商场。",
    offers: ["学生日全天特惠", "家庭套票立减"],
  },
  {
    id: "c06",
    name: "九七国际影城（天河城店）",
    brand: "九七国际影城",
    city: "广州",
    district: "天河区",
    address: "广州市天河区天河路 208 号天河城广场 7 层",
    phone: "020-3833-9700",
    rating: 4.7,
    logo: "",
    images: [
      "https://readdy.ai/api/search-image?query=spacious%20contemporary%20cinema%20lobby%20with%20warm%20wood%20and%20deep%20blue%20accents%2C%20hanging%20lights%2C%20welcoming%20architectural%20photography&width=1200&height=800&seq=cinema-hall-c06a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=modern%20cinema%20auditorium%20with%20ample%20legroom%20and%20deep%20blue%20seats%2C%20warm%20orange%20aisle%20lighting%2C%20cinematic%20architectural%20photography&width=1200&height=800&seq=cinema-hall-c06b&orientation=landscape",
    ],
    facilities: ["CINITY 影厅", "杜比全景声", "可在线选座", "免费停车"],
    intro:
      "广州天河城九七国际影城拥有 CINITY 高帧率影厅，画面与音效表现一流，坐拥天河核心商圈客流。",
    traffic: "地铁 1 号线 / 3 号线体育西路站步行 5 分钟。",
    offers: ["会员日 5 折", "观影满额赠饮品"],
  },
  {
    id: "c07",
    name: "CGV 影城（深圳万象城店）",
    brand: "CGV影城",
    city: "深圳",
    district: "罗湖区",
    address: "深圳市罗湖区宝安南路 1881 号万象城 4 层",
    phone: "0755-8266-3399",
    rating: 4.6,
    logo: "",
    images: [
      "https://readdy.ai/api/search-image?query=trendy%20minimal%20cinema%20lobby%20with%20concrete%20and%20deep%20blue%20accents%2C%20warm%20orange%20signage%2C%20architectural%20photography&width=1200&height=800&seq=cinema-hall-c07a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=screenx%20three%20panel%20cinema%20auditorium%20with%20immersive%20surround%20screens%2C%20deep%20blue%20ambient%20lighting%2C%20high%20tech%20architectural%20photography&width=1200&height=800&seq=cinema-hall-c07b&orientation=landscape",
    ],
    facilities: ["ScreenX", "4DX 影厅", "可在线选座", "咖啡吧"],
    intro:
      "深圳万象城 CGV 影城以 ScreenX 三面屏与 4DX 特效厅为特色，为深圳观众带来沉浸式观影新体验。",
    traffic: "地铁 1 号线大剧院站与万象城地下通道直达。",
    offers: ["工作日特惠场", "会员积分翻倍"],
  },
  {
    id: "c08",
    name: "横店影视城（春熙路店）",
    brand: "横店影视城",
    city: "成都",
    district: "锦江区",
    address: "成都市锦江区红星路三段 1 号 IFS 国际金融中心 6 层",
    phone: "028-8666-9700",
    rating: 4.7,
    logo: "",
    images: [
      "https://readdy.ai/api/search-image?query=vibrant%20cinema%20lobby%20with%20colorful%20movie%20posters%20and%20deep%20blue%20accent%20lighting%2C%20warm%20orange%20highlights%2C%20architectural%20photography&width=1200&height=800&seq=cinema-hall-c08a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=comfortable%20modern%20cinema%20auditorium%20with%20deep%20blue%20seats%20and%20large%20screen%2C%20warm%20orange%20accent%20lighting%2C%20cinematic%20architectural%20photography&width=1200&height=800&seq=cinema-hall-c08b&orientation=landscape",
    ],
    facilities: ["IMAX 影厅", "可在线选座", "会员储值", "茶饮吧"],
    intro:
      "成都春熙路横店影视城坐拥 IMAX 巨幕厅，结合本地特色茶饮服务，是成都潮流地标上的观影热门去处。",
    traffic: "地铁 2 号线 / 3 号线春熙路站步行 3 分钟。",
    offers: ["会员日 5 折", "学生特惠票"],
  },
  {
    id: "c09",
    name: "保利国际影城（西湖文化广场店）",
    brand: "保利国际影城",
    city: "杭州",
    district: "拱墅区",
    address: "杭州市拱墅区西湖文化广场 8 号 4 层",
    phone: "0571-8585-9700",
    rating: 4.5,
    logo: "",
    images: [
      "https://readdy.ai/api/search-image?query=calm%20minimal%20cinema%20lobby%20with%20soft%20lighting%20and%20deep%20blue%20accents%2C%20subtle%20orange%20warmth%2C%20architectural%20photography&width=1200&height=800&seq=cinema-hall-c09a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=modern%20cinema%20auditorium%20with%20deep%20blue%20seats%20and%20wide%20screen%2C%20warm%20orange%20aisle%20lighting%2C%20cinematic%20architectural%20photography&width=1200&height=800&seq=cinema-hall-c09b&orientation=landscape",
    ],
    facilities: ["杜比全景声", "可在线选座", "免费停车", "母婴室"],
    intro:
      "杭州西湖文化广场保利国际影城环境舒适、配套齐全，兼顾亲子与商务人群，是城北片区的观影优选。",
    traffic: "地铁 3 号线西湖文化广场站步行 5 分钟。",
    offers: ["亲子套票优惠", "周三会员日特惠"],
  },
];